/* Inline SVG icons used across the Golden Quest screens. Each one is a
   straight lift of the prototype markup, so paths and viewBoxes match the
   Figma export exactly; sizing comes from the surrounding CSS. */

export function BackIcon(props) {
  return (
    <svg {...props} viewBox="20.998 21.998 23.002 20.003" fill="none">
      <path fill="white" d="M23 31H43C43.2652 31 43.5196 31.1054 43.7071 31.2929C43.8946 31.4804 44 31.7348 44 32C44 32.2652 43.8946 32.5196 43.7071 32.7071C43.5196 32.8946 43.2652 33 43 33H23C22.7348 33 22.4804 32.8946 22.2929 32.7071C22.1054 32.5196 22 32.2652 22 32C22 31.7348 22.1054 31.4804 22.2929 31.2929C22.4804 31.1054 22.7348 31 23 31Z" />
      <path fill="white" d="M23.4138 31.9998L31.7078 40.2918C31.8956 40.4796 32.0011 40.7342 32.0011 40.9998C32.0011 41.2653 31.8956 41.52 31.7078 41.7078C31.5201 41.8956 31.2654 42.0011 30.9998 42.0011C30.7343 42.0011 30.4796 41.8956 30.2918 41.7078L21.2918 32.7078C21.1987 32.6149 21.1248 32.5046 21.0744 32.3831C21.024 32.2616 20.998 32.1313 20.998 31.9998C20.998 31.8683 21.024 31.738 21.0744 31.6165C21.1248 31.495 21.1987 31.3847 21.2918 31.2918L30.2918 22.2918C30.4796 22.104 30.7343 21.9985 30.9998 21.9985C31.2654 21.9985 31.5201 22.104 31.7078 22.2918C31.8956 22.4796 32.0011 22.7342 32.0011 22.9998C32.0011 23.2653 31.8956 23.52 31.7078 23.7078L23.4138 31.9998Z" />
    </svg>
  );
}

export function ShareIcon(props) {
  return (
    <svg {...props} viewBox="331.000 18.666 24.000 26.560" fill="none">
      <path fill="white" d="M351 37.4398C349.987 37.4398 349.08 37.8398 348.387 38.4665L338.88 32.9332C338.947 32.6265 339 32.3198 339 31.9998C339 31.6798 338.947 31.3732 338.88 31.0665L348.28 25.5865C349 26.2532 349.947 26.6665 351 26.6665C353.213 26.6665 355 24.8798 355 22.6665C355 20.4532 353.213 18.6665 351 18.6665C348.787 18.6665 347 20.4532 347 22.6665C347 22.9865 347.053 23.2932 347.12 23.5998L337.72 29.0798C337 28.4132 336.053 27.9998 335 27.9998C332.787 27.9998 331 29.7865 331 31.9998C331 34.2132 332.787 35.9998 335 35.9998C336.053 35.9998 337 35.5865 337.72 34.9198L347.213 40.4665C347.147 40.7465 347.107 41.0398 347.107 41.3332C347.107 43.4798 348.853 45.2265 351 45.2265C353.147 45.2265 354.893 43.4798 354.893 41.3332C354.893 39.1865 353.147 37.4398 351 37.4398Z" />
    </svg>
  );
}

export function ClockIcon(props) {
  return (
    <svg {...props} viewBox="125.000 64.000 14.000 14.000" fill="none">
      <path fill="#4A2C73" d="M132 64C128.134 64 125 67.1344 125 71C125 74.8656 128.134 78 132 78C135.866 78 139 74.8656 139 71C139 67.1344 135.866 64 132 64ZM132 76.8125C128.791 76.8125 126.188 74.2094 126.188 71C126.188 67.7906 128.791 65.1875 132 65.1875C135.209 65.1875 137.812 67.7906 137.812 71C137.812 74.2094 135.209 76.8125 132 76.8125Z" />
      <path fill="#4A2C73" d="M134.73 72.9781L132.502 71.3672V67.5C132.502 67.4312 132.445 67.375 132.377 67.375H131.625C131.556 67.375 131.5 67.4312 131.5 67.5V71.8031C131.5 71.8438 131.519 71.8813 131.552 71.9047L134.136 73.7891C134.192 73.8297 134.27 73.8172 134.311 73.7625L134.758 73.1531C134.798 73.0953 134.786 73.0172 134.73 72.9781Z" />
    </svg>
  );
}

export function ChevronIcon(props) {
  return (
    <svg {...props} viewBox="0 0 14 14" fill="none">
      <path d="M5 2.5L9.5 7 5 11.5" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function CheckCircleIcon(props) {
  return (
    <svg {...props} viewBox="0 0 14 14" fill="none">
      <circle cx="7" cy="7" r="7" fill="#36195D" />
      <path d="M4 7.2l2 2 4-4.4" stroke="#EFE3FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ChevronSmIcon(props) {
  return (
    <svg {...props} viewBox="0 0 12 12" fill="none">
      <path d="M4 2.5L8 6l-4 3.5" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function FaqIcon(props) {
  return (
    <svg {...props} viewBox="20.000 2138.000 24.000 24.000" fill="none">
      <path fill="white" d="M24 2145H22V2159C22 2160.1 22.9 2161 24 2161H38V2159H24V2145ZM40 2141H28C26.9 2141 26 2141.9 26 2143V2155C26 2156.1 26.9 2157 28 2157H40C41.1 2157 42 2156.1 42 2155V2143C42 2141.9 41.1 2141 40 2141ZM40 2155H28V2143H40V2155ZM33.51 2149.16C33.92 2148.43 34.69 2148 35.14 2147.36C35.62 2146.68 35.35 2145.42 34 2145.42C33.12 2145.42 32.68 2146.09 32.5 2146.65L31.13 2146.08C31.51 2144.96 32.52 2144 33.99 2144C35.22 2144 36.07 2144.56 36.5 2145.26C36.87 2145.86 37.08 2146.99 36.51 2147.83C35.88 2148.76 35.28 2149.04 34.95 2149.64C34.82 2149.88 34.77 2150.04 34.77 2150.82H33.25C33.26 2150.41 33.19 2149.74 33.51 2149.16ZM32.95 2152.95C32.95 2152.36 33.42 2151.91 34 2151.91C34.59 2151.91 35.04 2152.36 35.04 2152.95C35.04 2153.53 34.6 2154 34 2154C33.42 2154 32.95 2153.53 32.95 2152.95Z" />
    </svg>
  );
}

export function PlusIcon(props) {
  return (
    <svg {...props} viewBox="331.000 2138.000 24.000 24.000" fill="none">
      <path fill="white" d="M350.194 2150.81L350.194 2149.19L343.806 2149.19L343.806 2142.81H342.194L342.194 2149.19L335.806 2149.19L335.806 2150.81L342.194 2150.81L342.194 2157.19H343.806L343.806 2150.81L350.194 2150.81Z" />
    </svg>
  );
}

export function TncIcon(props) {
  return (
    <svg {...props} viewBox="20.000 2220.500 24.000 24.000" fill="none">
      <path fill="white" d="M33.9289 2225.5L38.2222 2230.33V2239.5H25.7778V2225.5H33.9289ZM33.9289 2223.5H25.7778C24.8 2223.5 24 2224.4 24 2225.5V2239.5C24 2240.6 24.8 2241.5 25.7778 2241.5H38.2222C39.2 2241.5 40 2240.6 40 2239.5V2230.33C40 2229.8 39.8133 2229.29 39.4756 2228.92L35.1822 2224.09C34.8533 2223.71 34.4 2223.5 33.9289 2223.5ZM27.5556 2235.5H36.4444V2237.5H27.5556V2235.5ZM27.5556 2231.5H36.4444V2233.5H27.5556V2231.5ZM27.5556 2227.5H33.7778V2229.5H27.5556V2227.5Z" />
    </svg>
  );
}

export function ArrowIcon(props) {
  return (
    <svg {...props} viewBox="335.000 2224.500 16.000 16.000" fill="none">
      <path fill="white" d="M343 2240.5L341.95 2239.42L348.125 2233.25H335V2231.75H348.125L341.95 2225.57L343 2224.5L351 2232.5L343 2240.5Z" />
    </svg>
  );
}

export function CopyIcon(props) {
  return (
    <svg {...props} viewBox="0 0 14 14" fill="none">
      <rect x="4.5" y="4.5" width="8" height="8" rx="1.5" stroke="#fff" />
      <path d="M9.5 4.5V3a1.5 1.5 0 0 0-1.5-1.5H3A1.5 1.5 0 0 0 1.5 3v5A1.5 1.5 0 0 0 3 9.5h1.5" stroke="#fff" />
    </svg>
  );
}

export function BellIcon(props) {
  return (
    <svg {...props} viewBox="144.856 767.444 14.200 14.792" fill="none">
      <path fill="#391B64" d="M151.5 782.236C151.78 782.23 152.049 782.124 152.258 781.939C152.468 781.753 152.606 781.5 152.647 781.223H150.309C150.351 781.507 150.495 781.767 150.714 781.953C150.933 782.14 151.212 782.24 151.5 782.236Z" />
      <path fill="#391B64" d="M158.1 779.502L157.949 779.369C157.52 778.987 157.145 778.549 156.833 778.067C156.493 777.401 156.289 776.675 156.233 775.929V773.734C156.231 773.467 156.208 773.201 156.162 772.938C155.409 772.783 154.733 772.373 154.248 771.777C153.763 771.181 153.499 770.435 153.5 769.667V769.387C153.036 769.159 152.537 769.009 152.024 768.942V768.382C152.024 768.225 151.962 768.074 151.851 767.963C151.739 767.852 151.588 767.789 151.431 767.789C151.274 767.789 151.123 767.852 151.012 767.963C150.9 768.074 150.838 768.225 150.838 768.382V768.965C149.689 769.127 148.638 769.699 147.878 770.575C147.119 771.452 146.702 772.574 146.704 773.734V775.929C146.649 776.675 146.445 777.401 146.104 778.067C145.798 778.548 145.429 778.986 145.007 779.369L144.856 779.502V780.756H158.1V779.502Z" />
      <path fill="#391B64" d="M156.833 771.889C158.061 771.889 159.056 770.894 159.056 769.667C159.056 768.439 158.061 767.444 156.833 767.444C155.606 767.444 154.611 768.439 154.611 769.667C154.611 770.894 155.606 771.889 156.833 771.889Z" />
    </svg>
  );
}

export function ToastCheckIcon(props) {
  return (
    <svg {...props} viewBox="0 0 10 10" fill="none">
      <path d="M2 5.2l2 2 4-4.4" stroke="#0E3B1F" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function LockChipIcon(props) {
  return (
    <svg {...props} viewBox="0 0 10 12" fill="none">
      <rect x="1" y="5" width="8" height="6" rx="1.5" fill="#fff" opacity=".9" />
      <path d="M3 5V3.5a2 2 0 0 1 4 0V5" stroke="#fff" strokeWidth="1.3" />
    </svg>
  );
}

export function LockBtnIcon(props) {
  return (
    <svg {...props} viewBox="0 0 14 16" width="14" height="16" fill="none">
      <rect x="1.5" y="7" width="11" height="8" rx="2" fill="currentColor" opacity=".9" />
      <path d="M4 7V5a3 3 0 0 1 6 0v2" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

/* tick in the streak card's corner badge and its referral "extra" line */
export function BadgeCheckIcon(props) {
  return (
    <svg {...props} viewBox="0 0 11 11" fill="none">
      <path d="M2 5.6l2.3 2.3L9 3.4" stroke="#F6D5AC" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/* circled tick on a completed streak's CTA */
export function DoneCheckIcon(props) {
  return (
    <svg {...props} viewBox="0 0 14 14" width="14" height="14" fill="none">
      <circle cx="7" cy="7" r="6.2" stroke="currentColor" strokeWidth="1.3" />
      <path d="M4.2 7.2l2 2 3.8-4.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function CloseIcon(props) {
  return (
    <svg {...props} viewBox="0 0 12 12" fill="none">
      <path d="M1 1l10 10M11 1L1 11" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

function GoldDiscBarsIcon(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none">
      <path d="M6 4h12l2 6H4l2-6Z" fill="#2A1450" />
      <path d="M3 13h8l2 6H1l2-6Z" fill="#2A1450" />
      <path d="M13 13h8l2 6H11l2-6Z" fill="#2A1450" />
    </svg>
  );
}

/* three stacked gold bars — the "Gold" row of the prizes sheet */
export function GoldBarsIcon(props) {
  return (
    <svg {...props} viewBox="0 0 72 50" width="40" height="28" fill="none">
      <path d="M20 2h32l6 18H14l6-18Z" fill="#F4D29E" stroke="#8A5410" strokeWidth="1.2" />
      <path d="M6 28h32l6 18H0l6-18Z" fill="#F4D29E" stroke="#8A5410" strokeWidth="1.2" />
      <path d="M34 28h32l6 18H28l6-18Z" fill="#F4D29E" stroke="#8A5410" strokeWidth="1.2" />
    </svg>
  );
}

function VoucherIcon(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none">
      <path d="M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4V8Z" stroke="#2A1450" strokeWidth="1.8" />
      <path d="M12 7v10" stroke="#2A1450" strokeWidth="1.8" strokeDasharray="2 2" />
    </svg>
  );
}

/* what sits inside the gold disc for a Gem reward, by API `kind` */
export function RewardIcon({ kind }) {
  switch (kind) {
    case 'GOLD': return <GoldDiscBarsIcon />;
    case 'VOUCHER': return <VoucherIcon />;
    case 'SATS': return <span className="gq-ric-txt gq-ric-sats">₿</span>;
    case 'CASHBACK': return <span className="gq-ric-txt">₹</span>;
    case 'BOOST': return <span className="gq-ric-txt">2×</span>;
    default: return <span className="gq-ric-txt">★</span>;
  }
}
